module.exports = __webpack_public_path__ + "static/Audit-3-219b438deec7ec40fe587123f06d6310.svg";